import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import API from '@sesame/web-api';

import { IRackComponent, IPortMap, ILoadState } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import { Spinner } from 'src/components/Spinner';
import { getRackComponentsByType } from './rackUtils';

interface IRackPortmapProps {
  rack: IRackComponent;
  elevationUpdateKey: number;
}

interface DisplayPortmap {
  switchLabel: string;
  portLabels: string[]
}


export const RackPortmap = ({ rack, elevationUpdateKey }: IRackPortmapProps) => {
  const  {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [portMap, setPortMap] = useState<IPortMap[]>([]);
  const [loadState, setLoadState] = useState<ILoadState>(ILoadState.NEW);

  const getRackPortmap = () => {
    getAccessTokenSilently().then(accessToken => {
    API.get(accessToken, `/api/v1/rack/${rack.rackId}/portmap`)
      .then(result => {
        setPortMap(result.data as IPortMap[])
        setLoadState(ILoadState.READY);
      })
      .catch(err => {
        Alert(AlertTypes.ERROR, err.message);
      })
    })
  }

  useEffect(() => getRackPortmap(), [elevationUpdateKey, getAccessTokenSilently]);

  if (isLoading || loadState == ILoadState.NEW || loadState == ILoadState.LOADING) {
    return <Spinner />
  }
  if (loadState == ILoadState.ERROR) {
    return <h1 className="uk-text-danger">Error loading portmap data</h1>
  }

  const switchMaps = createDisplayPortmap(rack, portMap);
  return <table>
    <tbody>
      {switchMaps.map(s => <tr key={s.switchLabel}>
        <td>{s.switchLabel}</td>
        {s.portLabels.map((p, i) => <td key={i}>
          {p ? <span className="active-portmap">{p}</span> : <span className="unused-portmap">Port {i + 1}</span>}
        </td>)}
      </tr>
      )}
    </tbody>
  </table>;
}

const createDisplayPortmap = (rack: IRackComponent, portMap: IPortMap[]) => {
  const switches = getRackComponentsByType(rack, 'Switches');
  switches.sort((a, b) => {
    if (a.location && b.location) {
      return a.location.ou > b.location.ou ? -1 : 1;
    }
    return a.location ? -1 : 1;
  });

  const switchMaps: DisplayPortmap[] = [];
  for (const s of switches) {
    const displayMap: DisplayPortmap = {
      switchLabel: s.label || '',
      portLabels: Array<string>(s.portCount).fill(''),
    }
    for (const p of portMap) {
      if (p.destination.label == displayMap.switchLabel) {
        displayMap.portLabels[p.destination.port - 1] +=
          `${p.source.location.ou}:${p.source.location.column}:${p.source.label.substring(0, 1)}${p.source.port} `
      } else if (p.source.label == displayMap.switchLabel) {
        displayMap.portLabels[p.source.port - 1] = `${p.destination.label}:${p.destination.port} `
      }
    }
    switchMaps.push(displayMap);
  }
  return switchMaps;
}
